<template>
  <div>
    <v-card>
      <v-navigation-drawer
          app
          class="sidebar"
          right
          v-model="rightDrawer"
          width="22em"
          color="primary"
          dark
      >
        <v-sheet class="gradient pa-2 mb-2">
          <div class="px-4">
            <np-date-picker dark v-model="selectedTimeframe" :timerange-presets="$store.getters.getTimeframePresets" @input="$store.dispatch('uploadFilter')"></np-date-picker>
          </div>
          <v-divider class="my-4"></v-divider>
          <v-checkbox hide-details :disabled="!sidebarReady" class="px-4" @click="compareChartToggle" v-model="compareChartEnabled" :label="$t('enable-compare-chart')"></v-checkbox>
          <v-checkbox hide-details  v-if="$store.getters.userHasReportAccess" :disabled="!sidebarReady" class="px-4" v-model="sourceCompareChartEnabled" :label="$t('enable-source-compare-chart')"></v-checkbox>

          <v-divider class="my-4"></v-divider>
          <v-icon class="pl-5">mdi-list-status</v-icon>
          <v-btn-toggle
              :disabled="!sidebarReady"
              class="ml-2 "
              v-model="sidebarMetricSelects"
              rounded
              dense
              multiple
              id="t_split"
          >

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                    color="#00303b"
                    v-on="on"
                    v-bind="attrs"
                    @input="afterMetricChange"
                >
                  <v-icon>mdi-web</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('sidebar-tooltip-show-websites') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="#00303b"
                    v-on="on"
                    v-bind="attrs"
                    @input="afterMetricChange"
                >
                  <v-icon>mdi-cellphone-link</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('sidebar-tooltip-show-devices') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="#00303b"
                    v-on="on"
                    v-bind="attrs"
                    @input="afterMetricChange"
                >
                  <v-icon>mdi-tab-unselected</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('sidebar-tooltip-show-adunits') }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="#00303b"
                    v-on="on"
                    v-bind="attrs"
                    @input="afterMetricChange"
                >
                  <v-icon>mdi-details</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('sidebar-tooltip-show-campaigns') }}</span>
            </v-tooltip>


          </v-btn-toggle>
          <v-divider class="my-4"></v-divider>
          <v-select hide-details :disabled="!sidebarReady" class="px-4" color="#00303B" prepend-icon="mdi-image-size-select-small" dense rounded flat solo-inverted :label="$t('granularity-selector')" :items="granularities" v-model="selectedGranularity"></v-select>
          <v-divider class="my-4"></v-divider>
          <!--          <v-autocomplete-->
<!--              id="t_timesel"-->
<!--              dark-->
<!--              class="mt-12 mb-2"-->
<!--              v-model="timeframeValue"-->
<!--              :items="$store.getters.getTimeframeSelectItems"-->
<!--              outlined-->
<!--              hide-details-->
<!--              dense-->
<!--              :label="this.$t('label-timeframe')"-->
<!--              @input="$store.dispatch('uploadFilter')"-->
<!--          >-->

<!--          </v-autocomplete>-->





<!--          <v-text-field-->
<!--              dense-->
<!--              v-model="search"-->
<!--              :label="this.$t('label-search')"-->
<!--              dark-->
<!--              rounded-->
<!--              flat-->
<!--              solo-inverted-->
<!--              hide-details-->
<!--              prepend-icon="mdi-magnify"-->
<!--              class="px-4"-->
<!--          ></v-text-field>-->

<!--          <v-tooltip top>-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--              <v-btn-->
<!--                  icon-->
<!--                  class="ml-5"-->
<!--                  v-on="on"-->
<!--                  v-bind="attrs"-->
<!--                  @click="treeviewOpen = []"-->
<!--              >-->
<!--                <v-icon>mdi-arrow-u-up-right-bold</v-icon>-->
<!--              </v-btn>-->
<!--            </template>-->
<!--            <span>{{ $t('sidebar-close-all') }}</span>-->
<!--          </v-tooltip>-->


          <v-row no-gutters>
            <v-col cols="10">
              <v-text-field
                  dense
                  v-model="search"
                  :label="this.$t('label-search')"
                  dark
                  rounded
                  flat
                  solo-inverted
                  hide-details
                  prepend-icon="mdi-magnify"
                  class="pl-5"
              ></v-text-field>
            </v-col>
            <v-col cols="auto">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon

                      v-on="on"
                      v-bind="attrs"
                      @click="treeviewOpen = []"
                  >
                    <v-icon>mdi-arrow-u-up-right-bold</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('sidebar-close-all') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>









        <v-treeview
            class="pt-1"
            color="primary"
            selected-color="primary lighten-2"
            id="t_filter"
            v-if="setupReady"
            :open="treeviewOpen"
            open-on-click
            v-model="sidebarFilterSelects"
            dense
            :items="filterItems"
            selectable
            :search="search"

        >
        </v-treeview>

        </v-sheet>
        <v-skeleton-loader
            v-show="!setupReady"
            class="mx-auto"
            max-width="300"
            height="800"
            type="image@3"
        ></v-skeleton-loader>


      </v-navigation-drawer>
    </v-card>
    <div class="text-center">
      <v-dialog
          v-model="customDateDialog"
          width="500"
      >

        <v-card class="pa-4">
          <v-card-title>
            {{ $t('sidebar-custom-date-title') }}
          </v-card-title>

          <v-date-picker
              no-title
              full-width
              v-model="customTimeframe"
              :first-day-of-week="1"
              range
              :max="moment().format('YYYY-MM-DD')"
          ></v-date-picker>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="applyCustomTimeframe()"
            >
              Apply
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import NpDatePicker from "@/components/np-date-picker.vue";
import {objectMap} from "@/tools/acrobatics";
import {DashboardStatus, SetupStatus} from "@/store/modules/statistics";

export default {
  name: "np-sidebar",
  components: {NpDatePicker},
  props: {
    rightDrawer: Boolean,
  },
  data() {
    return {
      test: null,
      search: "",
      customDateDialog: false,
      treeviewOpen: ['adunits'],
      moment: moment,
      timeframeValueTest: null,
      granularities: [
        { text: this.$t("granularity-day"), value: "day" },
        { text: this.$t("granularity-week"), value: "yearweek" },
        { text: this.$t("granularity-month"), value: "yearmonth" },
        { text: this.$t("granularity-year"), value: "year" },
      ],
      groupSelected: null,
    }
  },
  mounted() {
    // App.vue already triggers the setup; only retry here if it never ran or failed
    const setupStatus = this.$store.state.statistics.setupStatus
    if (setupStatus === SetupStatus.IDLE || setupStatus === SetupStatus.ERROR) {
      this.$store.dispatch("fetchDomains")
    }
  },
  methods: {
    applyCustomTimeframe() {
      this.customDateDialog = false
        // console.log("applyCustomTimeframe")
      this.$store.dispatch("uploadFilter")
      this.$store.dispatch("fetchReport")
    },
    afterMetricChange() {
        // console.log("afterMetricChange")
      this.$store.dispatch("uploadFilter")
      this.$store.dispatch("fetchReport")
    },
    compareChartToggle() {
      if (Object.keys(this.$store.getters.getCompareChartTimeframe).length === 0){
        let deference =moment.duration( moment(this.selectedTimeframe.end).diff(moment(this.selectedTimeframe.start)))
        let end = moment(this.selectedTimeframe.start).subtract(1, "days").format('YYYY-MM-DD');
        let start = moment(this.selectedTimeframe.start).subtract((deference.asDays() + 1), "days").format('YYYY-MM-DD');
        let timeframe = {
          base: {start: this.selectedTimeframe.start,end: this.selectedTimeframe.end},
          compare: {start: start,end: end}
        }
        this.$store.commit("setCompareChartTimeframe", timeframe)
      }

        // this.$store.dispatch('fetchCompare', this.$store.getters.getCompareChartTimeframe)
        // console.log("compareChartToggle")
        this.$store.dispatch('uploadFilter')


      if (this.compareChartEnabled){
        this.$emit('compare-toggle', true)
      }

    },
    applyAdunitGroup() {
      console.log("applyAdunitGroup")
      if (this.groupSelected === null) {
        return
      }
      console.log(this.groupSelected)
      const groups = [
          {name: 'desktop-top', adunitNames:[
              "banner",
              "billboard",
            ]},
          {name: 'desktop-right', adunitNames:[
              "sky"
            ]},
          {name: 'desktop-middle', adunitNames:[
              "middle1",
              "middle2",
              "middle3",
              "middle4",
              "mrec",
              "billboard_btf",
              "billboard_btf_10",
              "billboard_btf_11",
              "billboard_btf_12",
              "billboard_btf_2",
              "billboard_btf_3",
              "billboard_btf_4",
              "billboard_btf_5",
              "billboard_btf_6",
              "billboard_btf_7",
              "billboard_btf_8",
              "billboard_btf_9",
              "incontent1",
              "incontent2",
              "incontent3",
              "incontent4",
              "inpage",
              "mrec_btf",
              "mrec_btf_10",
              "mrec_btf_11",
              "mrec_btf_12",
              "mrec_btf_13",
              "mrec_btf_14",
              "mrec_btf_15",
              "mrec_btf_16",
              "mrec_btf_17",
              "mrec_btf_18",
              "mrec_btf_2",
              "mrec_btf_3",
              "mrec_btf_4",
              "mrec_btf_5",
              "mrec_btf_6",
              "mrec_btf_7",
              "mrec_btf_8",
              "mrec_btf_9",
            ]},
          {name: 'mobile-top', adunitNames:[]},
          {name: 'mobile-middle', adunitNames:[]},
          {name: 'mobile-middle1', adunitNames:[]},
      ]

      // create a new filterSelects that only applies the adunits from the group. This is a bit of a hack, but it works.
      let newFilterSelects = []
      for (const filterSelect of this.filterItems) {
        if (filterSelect.id === "adunits") {
          //only apply groups to domain finanzen.net
          for (const domain of filterSelect.children) {
            if (domain.name === "finanzen.net") {
              for (const adunit of domain.children) {
                for (const group of groups) {
                  if (group.name === this.groupSelected) {
                    if (group.adunitNames.includes(adunit.name)) {
                      newFilterSelects.push(adunit.id)
                      console.log("adding adunit to filterSelects: " + adunit.name)
                    }
                  }
                }
              }
            }

          }
        }
        if (filterSelect.id === "sources") {
          // activate only publisher source
          for (const source of filterSelect.children) {
            if (source.name !== "publisher") {
              continue
            }
            console.log("adding source to filterSelects: " + source.name)
            for (const campaign of source.children) {
              newFilterSelects.push(campaign.id)
              console.log("adding campaign to filterSelects: " + campaign.name)
            }
          }
        }
        if (filterSelect.id === "devices") {
          // determine devices based on group prefix (desktop-top should include "Desktop", mobile-top should include "Smartphone", "Tablet", "Feature phone")
          for (const device of filterSelect.children) {
            if (this.groupSelected.startsWith("desktop") && device.name === "Desktop") {
              newFilterSelects.push(device.id)
              console.log("adding device to filterSelects: " + device.name)
            }
            if (this.groupSelected.startsWith("mobile") && (device.name === "Smartphone" || device.name === "Tablet" || device.name === "Feature phone")) {
              newFilterSelects.push(device.id)
              console.log("adding device to filterSelects: " + device.name)
            }
          }
        }
        console.log("filterSelect")
        console.log(filterSelect)

      }

      console.log("newFilterSelects")
      console.log(newFilterSelects)

      this.sidebarFilterSelects = newFilterSelects
      this.$store.commit("setSidebarFilterSelects", newFilterSelects)
      this.$store.dispatch("fetchReport")

    },



  },
  computed: {
    sidebarReady() {
      return this.$store.getters.dashboardStatus !== DashboardStatus.LOADING
    },
    setupReady() {
      return this.$store.state.statistics.setupStatus === SetupStatus.READY
    },
    sidebarFilterSelects: {
      get() {
        return this.$store.state.statistics.sidebarFilterSelects
      },
      set(value) {
        this.$store.commit("setSidebarFilterSelects", value)
        this.$store.dispatch("fetchReport")
      }
    },
    selectedGranularity: {
      get() {
        return this.$store.state.statistics.selectedGranularity
      },
      set(value) {
        this.$store.commit("setSelectedGranularity", value)
        this.$store.dispatch("fetchReport")
      }
    },
    compareChartEnabled: {
      get() {
        return this.$store.getters.getShowCompareChart
      },
      set(bool) {
        this.$store.commit("setShowCompareChart", bool)
      }
    },
    sourceCompareChartEnabled: {
      get() {
        return this.$store.getters.getShowSourceCompareChart
      },
      set(bool) {
        this.$store.commit("setShowSourceCompareChart", bool)
      }
    },
    sidebarMetricSelects: {
      get() {
        return this.$store.state.statistics.sidebarMetricSelects
      },
      set(value) {
        this.$store.commit("setSidebarMetricSelects", value)
      }
    },
    timeframeValue: {
      get() {
        return this.$store.state.statistics.timeframe.value
      },
      set(value) {
        this.$store.commit("setTimeframeValue", value)
        if (value === "custom") {
          this.customDateDialog = true
        } else {
          this.$store.dispatch("fetchReport")
        }
      }
    },
    selectedTimeframe: {
      get() {
        return this.$store.getters.getSelectedTimeframe
      },
      set(value) {
        this.$store.commit("setSelectedTimeframe", value)
        this.$store.dispatch("fetchReport")
      }
    },
    timeframe: {
      get() {
        return this.$store.state.statistics.timeframe
      }
    },
    customTimeframe: {
      get() {
        return this.$store.state.statistics.customTimeframe
      },
      set(value) {
        this.$store.commit("setCustomTimeframe", value)
      }
    },

    filterItems() {
      let items = []


      items.push({
        id: "devices",
        name: "Devices",
        icon: "mdi-cellphone-link",
        children: this.$store.state.statistics.deviceFilter.map(device => {
          return {
            id: device.name,
            name: device.name
          }
        })
      });
      items.push({
        id: "adunits",
        name: "Websites >> Adunits",
        icon: "mdi-tab-unselected",
        children: this.$store.state.statistics.domains.map(domain => {
          return {
            name: domain.name,
            id: "adunits_" + domain.id,
            children: domain.adunits.slice().sort((a, b) => a.name.localeCompare(b.name))
          }
        }).sort((a, b) => a.name.localeCompare(b.name))
      });

      const sources = [];

      for (const sourceKey in this.$store.state.statistics.sources) {
        const campaigns = [];
        const campaignsData = this.$store.state.statistics.sources[sourceKey];

        for (const campaignKey in campaignsData) {
          campaigns.push({ name: campaignsData[campaignKey], id: campaignKey });
        }

        sources.push({ name: sourceKey, id: sourceKey, children: campaigns });
      }

      items.push({
        id: "sources",
        name: this.$store.getters.t("sidebar-filter-sources"),
        icon: "mdi-tab-unselected",
        children: sources
      })


      return items

    },
    domainList() {
      return this.$store.state.statistics.domains.map(domain => {
        return {text: domain.name, value: domain.id}
      })
    },
    adunitItems() {
      return [{
        name: "Adunits",
        icon: "mdi-tab-unselected",
        id: "adunits",
        children: this.$store.state.statistics.domains.map(domain => {
          return {name: domain.name, id: domain.id, children: domain.adunits}
        })
      }]

    }
  }
}
</script>

<style scoped>
.sidebar {
  z-index: 1;
  padding-top: 4em;

}

.gradient {
  background: linear-gradient(to bottom, #00303b, #00586c);
}
</style>
